import React from 'react';
import { FiSearch } from 'react-icons/fi';
import { useIntl, FormattedMessage } from 'react-intl';
import { Link, useHistory, useLocation } from 'react-router-dom';

import Button from '~components/button';
import { buildAllMatchesSearch } from '~components/listing/newMatchesParams';

const NoResults = ({ variant = 'default' }) => {
  const intl = useIntl();
  const history = useHistory();
  const location = useLocation();

  if (variant === 'new-matches') {
    return (
      <div className="c-matches__no-results">
        <FiSearch />
        <strong>
          <FormattedMessage
            id="components.listing.new-matches-empty.title"
            defaultMessage="No new matches right now"
          />
        </strong>
        <span>
          <FormattedMessage
            id="components.listing.new-matches-empty.caption"
            defaultMessage="Try viewing all matching profiles instead."
          />
        </span>
        <Button
          type="button"
          className="c-btn c-matches__subscription-text l-grey"
          onClick={() =>
            history.replace({
              pathname: location.pathname,
              search: buildAllMatchesSearch(location.search),
            })
          }
        >
          <FormattedMessage
            id="components.listing.new-matches-empty.button"
            defaultMessage="Show all matching profiles"
          />
        </Button>
      </div>
    );
  }

  return (
    <div className="c-matches__no-results">
      <FiSearch />
      <strong>
        {intl.formatMessage({ id: 'containers.customers.list.no-results.title', defaultMessage: 'No results found' })}
      </strong>
      <span>
        {intl.formatMessage({
          id: 'containers.customers.list.no-results.edit-caption',
          defaultMessage: 'Please try to change your location.',
        })}
      </span>
      <Link to="/edit-offer">
        <Button type="button" className="c-btn c-matches__subscription-text l-grey">
          {intl.formatMessage({
            id: 'containers.customers.list.no-results.edit-button',
            defaultMessage: 'Edit advertisement',
          })}
        </Button>
      </Link>
    </div>
  );
};

export default NoResults;
